import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/Humanity/2024/Inhouse/1.jpg';
// import p2 from 'assests/Photos/Clubs/Humanity/2024/Inhouse/2.jpg';
// import p3 from 'assests/Photos/Clubs/Humanity/2024/Inhouse/3.jpg';
// import p4 from 'assests/Photos/Clubs/Humanity/2024/Inhouse/4.jpg';


// import Ecoclub2023 from 'views/EnvironmentDay2023/Ecoclub2023';


import { Typography } from '@mui/material';
import Container from 'components/Container';
// import Sidebar2023 from './Sidebar2023';
import Sidebar2023 from 'views/Humanity2023/Sidebar2023';
import Sidebar2022 from 'views/HumanityClub/components/Sidebar2022';
import Sidebar2024 from '../Humanity2023/Sidebar2024';
import Sidebar2025 from '../Humanity2023/Sidebar2025';


const MootCourt2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/association/Humanity/MootCourt/8.webp`;
 


  const photos = [
    {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
},
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},


      
  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h5' align='center' >
      MOOT COURT - 2025  
                                </Typography>
                                <br></br>
                                {/* <Typography variant='h7' align='justify' >
                                Class 4: Diversity Montage
                                Class 5: Continental Montage 

                                </Typography> */}
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 9-12  &  Date: 04 July 2025
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
     National Public School, Yeshwanthpur hosted in-house Moot Court session—a simulated court proceeding on Friday, 04 July 2025.
     Students were grouped into teams, each representing either the plaintiff or the defendant. A total of five Moot Court cases were presented, covering a range of topics including constitutional law, criminal law, civil law, and contract law.
     <br></br>
     Participants demonstrated commendable legal insight and analytical thinking as they argued their cases. The event was designed to offer students a hands-on experience of courtroom proceedings, sharpen their advocacy and public speaking skills, and deepen their understanding of the Indian legal system.
     <br></br>
     The teams were evaluated based on their legal reasoning, interpretation and application of law, clarity of argument, presentation style, courtroom decorum and their ability to respond effectively to questions.
     <br></br>
    </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Moot Court in Session: Sharpening Minds, Shaping Advocates.”

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025 />
             </Box>

             <Box marginBottom={4}>
               <Sidebar2022 />
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default MootCourt2025;